import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
const Loading = () => {
    return (
        <div align="center" style={{ marginTop : 50 }}><CircularProgress /></div>
    );
};
export default Loading;